module.exports = __webpack_public_path__ + "static/media/loading_dark.297b4fc6.gif";